/**
 * @file Identifies whether an investment uses the joint profile type.
 */
import { INVESTMENT_PROFILE_TYPE_JOINT } from "@components/Domain";

type Investment = {
  profileType?: string;
};

/**
 * Identifies whether an investment uses the joint profile type.
 */
const isJointInvestment = ({ profileType }: Investment): boolean => {
  const isJoint = profileType === INVESTMENT_PROFILE_TYPE_JOINT;

  return isJoint;
};

export default isJointInvestment;
